import { Plugin, PluginId } from "..";
import { defaultVibEventDataOptions } from "./vib-event-data-config";
import { defaultVibEventOptions } from "./vib-event-options";

const id: PluginId = "vib-event";

export const VibEvent: Plugin = {
	id,
	type: "event",
	header: {
		visible: true,
		edit: true,
		fullscreen: true,
	},
	name: "vibEvent",
	component: defineAsyncComponent(() => import("./VibEventPlugin.vue")),
	config: defineAsyncComponent(() => import("./VibEventPluginConfig.vue")),
	dataConfig: defineAsyncComponent(() => import("./VibEventDataConfig.vue")),
	defaultDataResolver: () => defaultVibEventDataOptions,
	defaultOptionsResolver: () => defaultVibEventOptions,
	dimension: {
		minHeight: 10,
		minWidth: 6,
	},

	currentVersion: 1,
	migrations: {},
};
